import { useReducer } from 'react'

const initialBeeState = {
  instance: {},
  template: {},
  rows: [],
  client: {},
  config: {},
  theme: '',
}

const beeReducer = (state, action) => {
  return {
    ...state,
    ...action.payload
  }
}

const useBee = () => {
  const [store, dispatch] = useReducer(beeReducer, initialBeeState)

  return { store, dispatch }
}

export default useBee
